import { Injectable, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Injectable({
    providedIn: 'root'
  })
  export class UtmService {
    private pageUtmMediumList: string[] = [];
  
    constructor(@Inject(DOCUMENT) private dom: Document) {}
  
    setPageUtmMediumList(list: string[]) {
      this.pageUtmMediumList = list.map(v => v.toLowerCase().trim());
    }
  
    shouldHideProgramsBasedOnUTM(): boolean {
      const urlParams = new URLSearchParams(this.dom.location.search);
      const utmMediumParam = urlParams.get('utm_medium');
      if (!utmMediumParam) return false;
      const qspValues = utmMediumParam
        .split(',')
        .map(val => val.trim().toLowerCase());
      return qspValues.some(val => this.pageUtmMediumList.includes(val));
    }
  }
  